// Mock data for MR Excursion Punta Cana Clone

export const tours = [
  {
    id: 1,
    title: "Isla Saona Clásica",
    image: "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/h8hivhm8_IMG-20260122-WA0046.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/h8hivhm8_IMG-20260122-WA0046.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/kp2cq5zj_IMG-20260122-WA0051.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/zv8b8d87_IMG-20260122-WA0045.jpg"
    ],
    locations: ["Punta Cana", "Saona y Bayahíbe"],
    duration: "1 Día",
    transport: "Ida y Vuelta",
    originalPrice: 89,
    salePrice: 55,
    childPrice: 45,
    priceLabel: "por persona",
    isOffer: true,
    category: "Excursiones",
    tag: "Por Mar",
    description: "La Isla Saona es parte del Parque Nacional del Este, un paraíso tropical con playas de arena blanca y aguas cristalinas color turquesa. Una experiencia inolvidable navegando por el Mar Caribe.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Guía turístico en español",
      "Navegación en lancha rápida y catamarán",
      "Parada en Piscina Natural con estrellas de mar",
      "Almuerzo buffet en la playa",
      "Barra libre (ron, cerveza, refrescos, agua)",
      "Snorkeling en el Mar Caribe",
      "Animación y música dominicana a bordo",
      "2.5 horas en la playa (aproximadamente)"
    ],
    schedule: [
      { title: "Recogida en hotel", desc: "Te recogemos en tu hotel y nos dirigimos al pueblo de Bayahíbe (aprox. 1 hora)." },
      { title: "Piscina Natural", desc: "Parada para nadar con estrellas de mar gigantes y brindis típico dominicano." },
      { title: "Isla Saona", desc: "Tiempo libre para disfrutar de la playa paradisíaca, nadar y relajarte." },
      { title: "Almuerzo Buffet", desc: "Delicioso almuerzo dominicano con arroz, pollo, cerdo, ensaladas y bebidas." },
      { title: "Regreso en Catamarán", desc: "Viaje de regreso con música, baile y bebidas incluidas." }
    ],
    recommendations: "Traje de baño, sandalias, gafas de sol, gorra, protector solar, toalla, efectivo para propinas"
  },
  {
    id: 2,
    title: "Santo Domingo - City Tour",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/2jwz9quo_IMG-20260123-WA0057.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/2jwz9quo_IMG-20260123-WA0057.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/d8ne61xi_IMG-20260123-WA0055.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/vn1jet9h_IMG-20260123-WA0052.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/eocgoulo_IMG-20260123-WA0049.jpg"
    ],
    locations: ["Punta Cana", "Santo Domingo"],
    duration: "Día Completo",
    transport: "Ida y Vuelta",
    originalPrice: 90,
    salePrice: 47,
    childPrice: 35,
    priceLabel: "por persona",
    isOffer: true,
    category: "Excursiones",
    tag: "Cultural",
    description: "Visita la capital más antigua del Nuevo Mundo. Santo Domingo ofrece historia, cultura y arquitectura colonial española en cada rincón de su Zona Colonial, Patrimonio de la Humanidad.",
    includes: [
      "Transporte ida y vuelta en autobús con A/C",
      "Guía turístico profesional",
      "Recorrido por la Zona Colonial",
      "Visita al Alcázar de Colón",
      "Catedral Primada de América",
      "Calle Las Damas",
      "Almuerzo típico dominicano",
      "Tiempo libre para compras"
    ],
    schedule: [
      { title: "Salida desde Punta Cana", desc: "Recogida en tu hotel temprano en la mañana." },
      { title: "Zona Colonial", desc: "Recorrido guiado por las calles históricas y monumentos." },
      { title: "Almuerzo", desc: "Comida típica dominicana en restaurante local." },
      { title: "Tiempo libre", desc: "Compras y exploración por tu cuenta." },
      { title: "Regreso", desc: "Retorno a tu hotel en Punta Cana." }
    ],
    recommendations: "Ropa cómoda, zapatos para caminar, cámara fotográfica, efectivo para compras"
  },
  {
    id: 3,
    title: "Isla Catalina",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/SNORKEL-ISLA-CATALINA-1357x905px-Stay-Happy-RD-460x307.jpg",
    gallery: [
      "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/SNORKEL-ISLA-CATALINA-1357x905px-Stay-Happy-RD.jpg"
    ],
    locations: ["La Romana", "Punta Cana"],
    duration: "1 Día",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 70,
    childPrice: 50,
    priceLabel: "por persona",
    isOffer: false,
    category: "Excursiones",
    tag: "Por Mar",
    description: "Isla Catalina es famosa por sus arrecifes de coral y aguas cristalinas perfectas para snorkeling. Una pequeña isla paradisíaca con playas vírgenes ideales para un día de aventura.",
    includes: [
      "Transporte ida y vuelta",
      "Navegación en catamarán",
      "Equipo de snorkeling",
      "Almuerzo buffet en la playa",
      "Bebidas incluidas",
      "Guía bilingüe",
      "Música y animación"
    ],
    schedule: [
      { title: "Recogida", desc: "Salida desde tu hotel hacia el puerto de La Romana." },
      { title: "Navegación", desc: "Viaje en catamarán hacia Isla Catalina." },
      { title: "Snorkeling", desc: "Exploración del arrecife de coral con equipo incluido." },
      { title: "Playa y almuerzo", desc: "Tiempo libre en la playa y almuerzo buffet." },
      { title: "Regreso", desc: "Navegación de vuelta y transporte a tu hotel." }
    ],
    recommendations: "Traje de baño, toalla, protector solar biodegradable, cámara acuática"
  },
  {
    id: 4,
    title: "Isla Saona VIP - Experiencia Exclusiva",
    image: "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/k0rzhf4s_IMG-20260122-WA0050.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/k0rzhf4s_IMG-20260122-WA0050.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/7qxq73iq_IMG-20260122-WA0052.jpg"
    ],
    locations: ["Punta Cana", "Saona y Bayahíbe"],
    duration: "1 Día",
    transport: "Lancha Rápida Privada",
    originalPrice: null,
    salePrice: 125,
    childPrice: 80,
    priceLabel: "por persona",
    isOffer: false,
    category: "Excursiones",
    tag: "VIP",
    description: "Vive Isla Saona como pocos la conocen. Un tour VIP, privado y organizado, diseñado para quienes buscan comodidad, exclusividad y tiempo de calidad en cada parada. Lancha rápida privada, grupos pequeños, sin esperas, sin multitudes, sin barcos llenos. Salidas: Lunes, Miércoles y Viernes.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Lancha rápida privada VIP",
      "Visita a 5 playas paradisíacas",
      "Piscina Natural (zona exclusiva) con estrellas de mar",
      "Paseo por los manglares (tortugas y mantarrayas)",
      "Playa Catuano (playa virgen)",
      "Playa del Toro (aguas turquesas)",
      "Playa Mano Juan + Pueblo Mano Juan",
      "Agua, Ron, Coca-Cola, Cerveza",
      "Buffet en la playa",
      "Chalecos salvavidas",
      "Guía y asistencia personalizada"
    ],
    schedule: [
      { title: "Recogida (7:00-8:00 AM)", desc: "Transporte desde tu hotel. Puntualidad requerida." },
      { title: "Piscina Natural", desc: "Aguas cristalinas, estrellas de mar, ambiente privado." },
      { title: "Manglares", desc: "Avistamiento de tortugas y mantarrayas." },
      { title: "Playa Catuano", desc: "Playa virgen ideal para fotos." },
      { title: "Playa del Toro", desc: "Aguas turquesas y tiempo libre." },
      { title: "Mano Juan", desc: "Visita al pueblecito típico y almuerzo buffet." }
    ],
    recommendations: "Puntualidad obligatoria. Traje de baño, toalla, protector solar, cámara. La lancha sale a la hora programada. Plazas limitadas por día.",
    departureDays: ["Lunes", "Miércoles", "Viernes"]
  },
  {
    id: 5,
    title: "Buceo Isla Catalina",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/BUCEO-ISLA-CATALINA-1357x905px-Stay-Happy-RD-460x307.jpg",
    gallery: [
      "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/BUCEO-ISLA-CATALINA-1357x905px-Stay-Happy-RD.jpg"
    ],
    locations: ["La Romana", "Punta Cana"],
    duration: "Día Entero",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 150,
    childPrice: null,
    priceLabel: "por persona",
    isOffer: false,
    category: "Excursiones",
    tag: "Aventura",
    description: "Descubre el mundo submarino de Isla Catalina con esta excursión de buceo. Arrecifes de coral, peces tropicales y una experiencia única bajo el Mar Caribe.",
    includes: [
      "Transporte ida y vuelta",
      "Equipo completo de buceo",
      "Instructor certificado PADI",
      "2 inmersiones",
      "Almuerzo incluido",
      "Bebidas",
      "Seguro de buceo"
    ],
    schedule: [
      { title: "Recogida", desc: "Salida temprana desde tu hotel." },
      { title: "Briefing", desc: "Instrucciones de seguridad y preparación." },
      { title: "Primera inmersión", desc: "Buceo en el arrecife de coral." },
      { title: "Descanso y almuerzo", desc: "Tiempo para comer y recuperar energías." },
      { title: "Segunda inmersión", desc: "Exploración de otra zona del arrecife." }
    ],
    recommendations: "Certificación de buceo requerida o curso de iniciación disponible"
  },
  {
    id: 6,
    title: "Buggys Macao",
    image: "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/knr6f613_IMG-20260122-WA0055.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/knr6f613_IMG-20260122-WA0055.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/ixcb8kz7_IMG-20260122-WA0056.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/ze5mjiwr_IMG-20260122-WA0057.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/u3ic4rcx_IMG-20260122-WA0058.jpg",
      "https://customer-assets.emergentagent.com/job_canatours-copy/artifacts/su2hh33r_IMG-20260122-WA0059.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "4 Horas",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 55,
    childPrice: 30,
    priceLabel: "por pareja",
    extraPrice: "$30 por persona adicional",
    isOffer: false,
    category: "Aventura",
    tag: "Off-Road",
    description: "Aventura en buggy por los campos y playas de Macao. Conduce tu propio buggy por caminos de tierra, visita una plantación de café y termina en la hermosa playa de Macao.",
    includes: [
      "Transporte ida y vuelta",
      "Buggy para 2 personas",
      "Guía experto",
      "Casco y gafas de protección",
      "Visita a plantación de café y cacao",
      "Degustación de café y chocolate",
      "Tiempo en Playa Macao",
      "Fotos y videos del recorrido"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel." },
      { title: "Instrucciones", desc: "Briefing de seguridad y manejo del buggy." },
      { title: "Aventura Off-Road", desc: "Recorrido por caminos de tierra y campos." },
      { title: "Plantación", desc: "Visita y degustación de café y chocolate." },
      { title: "Playa Macao", desc: "Tiempo libre en la playa más hermosa." }
    ],
    recommendations: "Ropa que pueda ensuciarse, zapatos cerrados, gafas de sol, protector solar"
  },
  {
    id: 7,
    title: "Canopy Zip Lines Bávaro",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Canopy-Zip-Lines-Bavaro-Punta-Cana-Tour-Excursion-1357x905px-Stayhappyrd-2-460x307.jpg",
    gallery: [
      "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Canopy-Zip-Lines-Bavaro-Punta-Cana-Tour-Excursion-1357x905px-Stayhappyrd-2.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "4 Horas",
    transport: "Ida y Vuelta",
    originalPrice: 95,
    salePrice: 65,
    childPrice: 45,
    priceLabel: "por persona",
    isOffer: true,
    category: "Aventura",
    tag: "Adrenalina",
    description: "Vuela sobre la selva tropical de Punta Cana en las tirolesas más emocionantes del Caribe. 12 cables diferentes con vistas espectaculares de la vegetación dominicana.",
    includes: [
      "Transporte ida y vuelta",
      "12 tirolesas diferentes",
      "Equipo de seguridad completo",
      "Guías certificados",
      "Bebidas refrescantes",
      "Fotos del recorrido",
      "Seguro de accidentes"
    ],
    schedule: [
      { title: "Recogida", desc: "Transporte desde tu hotel." },
      { title: "Equipamiento", desc: "Colocación de arnés y equipo de seguridad." },
      { title: "Tirolesas", desc: "Recorrido por las 12 tirolesas sobre la selva." },
      { title: "Descanso", desc: "Bebidas y refrigerio incluido." },
      { title: "Regreso", desc: "Transporte de vuelta al hotel." }
    ],
    recommendations: "Ropa cómoda, zapatos cerrados, no llevar objetos sueltos"
  },
  {
    id: 8,
    title: "Disco Imagine Punta Cana - La Cueva",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Disco-Imagine-La-Cueva-Punta-Cana-1357x905px-Stayhappyrd-1-460x307.jpg",
    gallery: [
      "https://potetourstransferpuntacana.com/wp-content/uploads/2021/03/Disco-Imagine-La-Cueva-Punta-Cana-1357x905px-Stayhappyrd-1.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "5 Horas",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 60,
    childPrice: null,
    priceLabel: "por persona",
    isOffer: false,
    category: "Vida Nocturna",
    tag: "Fiesta",
    description: "La discoteca más famosa del Caribe, construida dentro de una cueva natural de 10,000 años. Tres ambientes diferentes con música latina, electrónica y reggaetón.",
    includes: [
      "Transporte ida y vuelta",
      "Entrada a la discoteca",
      "Acceso a las 3 cuevas/ambientes",
      "Una bebida de bienvenida",
      "Acceso VIP disponible"
    ],
    schedule: [
      { title: "Recogida nocturna", desc: "Te buscamos en tu hotel alrededor de las 10 PM." },
      { title: "Llegada", desc: "Entrada a la cueva más espectacular del Caribe." },
      { title: "Fiesta", desc: "Baila toda la noche en los 3 ambientes diferentes." },
      { title: "Regreso", desc: "Transporte de vuelta cuando termine la fiesta." }
    ],
    recommendations: "Vestimenta elegante casual, mayores de 18 años, identificación requerida"
  },
  {
    id: 9,
    title: "Dolphin Explorer",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/e68j6a7y_dolphin-adventure-5.webp",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/e68j6a7y_dolphin-adventure-5.webp",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/ypu05dst_explorer-03.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/s9jdlcop_dolphin_explorer_10.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "40-60 minutos",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 120,
    childPrice: null,
    priceLabel: "desde",
    isOffer: false,
    category: "Experiencias",
    tag: "Delfines",
    description: "Vive una experiencia única con delfines. Tenemos tres actividades diferentes para ti. Todas incluyen beso con león marino y entrada a las aves.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Beso con león marino",
      "Entrada a las aves",
      "Guía profesional",
      "Equipo de seguridad"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel." },
      { title: "Llegada al parque", desc: "Instrucciones de seguridad y preparación." },
      { title: "Actividad con delfines", desc: "Interacción o nado según el programa elegido." },
      { title: "León marino y aves", desc: "Beso con león marino y visita a las aves." },
      { title: "Regreso", desc: "Transporte de vuelta al hotel." }
    ],
    recommendations: "Traer traje de baño, toalla y protector solar.",
    activities: [
      {
        name: "Interacción con 1 Delfín",
        duration: "40 minutos",
        price: 120,
        priceFromBayahibe: 140,
        description: "40 minutos de contacto directo con el delfín. Niños menos de 1 metro gratis. Embarazadas pueden participar."
      },
      {
        name: "Nado con 1 Delfín",
        duration: "50 minutos",
        price: 130,
        priceFromBayahibe: 145,
        description: "50 minutos nadando con el delfín. No apto para embarazadas ni niños menores de 1 metro."
      },
      {
        name: "Nado con 2 Delfines",
        duration: "60 minutos",
        price: 210,
        priceFromBayahibe: null,
        description: "60 minutos nadando con 2 delfines simultáneamente. No apto para embarazadas ni niños menores de 1 metro."
      }
    ]
  },
  {
    id: 12,
    title: "Adventure Buggies Macao - Cueva Privada + Show Taíno",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/0qgf6oqr_caption.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/0qgf6oqr_caption.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/dtvwn9tb_Rectangle-10-37.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/8d2naixh_experience-the-top-rated.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "4-5 Horas",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 150,
    childPrice: null,
    priceLabel: "Buggy Doble",
    extraPrice: "Buggy Familiar: $210",
    isOffer: false,
    category: "Aventura",
    tag: "Off-Road",
    description: "Una aventura todoterreno única que incluye visita al Parque Domitai, show cultural taíno, degustación de productos típicos y tiempo para nadar en una cueva privada (cenote) con aguas cristalinas.",
    includes: [
      "Transporte ida y vuelta desde el hotel",
      "Buggy para todo el recorrido",
      "Guía profesional durante la excursión",
      "Recorrido por caminos todoterreno",
      "Senderos con barro y paisajes naturales",
      "Visita al Parque Domitai",
      "Show cultural taíno",
      "Explicación sobre historia y tradiciones taínas",
      "Degustación de Café, Cacao/Chocolate y Mamajuana",
      "Visita y tiempo para nadar en cueva privada (cenote)",
      "Equipo de seguridad (casco)",
      "Agua durante el recorrido"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel." },
      { title: "Aventura Off-Road", desc: "Recorrido en buggy por caminos de tierra y barro." },
      { title: "Parque Domitai", desc: "Show taíno y degustación de productos típicos." },
      { title: "Cueva Privada", desc: "Tiempo para nadar en el cenote de aguas cristalinas." },
      { title: "Regreso", desc: "Transporte de vuelta al hotel." }
    ],
    recommendations: "Ropa que pueda ensuciarse, zapatos cerrados, traje de baño, toalla, protector solar."
  },
  {
    id: 13,
    title: "Pesca en Altamar",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/04gs517r_IMG-20260123-WA0096.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/04gs517r_IMG-20260123-WA0096.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/en1wn2o1_IMG-20260123-WA0094.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/7x9uvmea_IMG-20260123-WA0091.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/0f0eofse_IMG-20260123-WA0090.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/kh5g5mxs_IMG-20260123-WA0093.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "Medio Día",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 120,
    childPrice: null,
    priceLabel: "por persona",
    isOffer: false,
    category: "Aventura",
    tag: "Pesca",
    description: "Embárcate en un viaje lleno de aventura y pesca en altamar como todo un experto. Navega por las aguas cristalinas del Caribe dominicano y disfruta de una experiencia inolvidable pescando al más puro estilo de Punta Cana. ¿Te lo vas a perder?",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Materiales de pesca",
      "Refrigerios",
      "Agua",
      "Sodas (Coca-Cola, Pepsi, 7up)",
      "Ron",
      "Capitán y tripulación experta"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel temprano." },
      { title: "Embarque", desc: "Salida desde el puerto hacia aguas profundas." },
      { title: "Pesca", desc: "Horas de pesca con equipo profesional incluido." },
      { title: "Refrigerios", desc: "Disfruta de bebidas y snacks a bordo." },
      { title: "Regreso", desc: "Navegación de vuelta y transporte al hotel." }
    ],
    recommendations: "Ropa cómoda, gorra, gafas de sol, protector solar. Se recomienda tomar medicina para el mareo si es susceptible."
  },
  {
    id: 14,
    title: "Coco Bongo Show & Disco",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/8l8i4qc0_1d7f1b30-9cdb-40e0-aec7-6ceafe8fcc5d.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/8l8i4qc0_1d7f1b30-9cdb-40e0-aec7-6ceafe8fcc5d.jpeg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/u1f3biv6_89.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/mqjf175n_Coco-Bongo-Punta-Cana-Mesas-VIP.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/sq02twlp_19.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/rkoedn78_photographed-alain-strassberg.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "Toda la noche",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 95,
    childPrice: null,
    priceLabel: "desde",
    isOffer: false,
    category: "Vida Nocturna",
    tag: "Fiesta",
    description: "El club nocturno más famoso del Caribe. Coco Bongo es conocido por sus presentaciones llenas de energía, shows espectaculares y entretenimiento inolvidable. Ambos paquetes incluyen transporte ida y vuelta desde tu hotel.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Entrada a Coco Bongo",
      "Barra libre toda la noche",
      "Show espectacular incluido"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel por la noche." },
      { title: "Llegada", desc: "Entrada al club más famoso del Caribe." },
      { title: "Show", desc: "Disfruta del espectáculo único lleno de energía." },
      { title: "Fiesta", desc: "Baila toda la noche con barra libre." },
      { title: "Regreso", desc: "Transporte de vuelta cuando termine." }
    ],
    recommendations: "Vestimenta elegante casual, mayores de 18 años, identificación requerida.",
    activities: [
      {
        name: "Paquete Premium",
        duration: "Toda la noche",
        price: 190,
        priceFromBayahibe: null,
        description: "Barra libre premium con bebidas de alta calidad. Servicio personalizado con mesero dedicado. Asientos reservados con la mejor vista del show (2do o 3er nivel). Entrada prioritaria sin filas."
      },
      {
        name: "Paquete Regular",
        duration: "Toda la noche",
        price: 95,
        priceFromBayahibe: null,
        description: "Barra libre con bebidas estándar ilimitadas. Snacks/bocadillos ligeros incluidos. Vista desde el piso principal (de pie). Opción de comprar mesa al llegar (sujeto a disponibilidad)."
      }
    ]
  },
  {
    id: 16,
    title: "Paseo a Caballos - Playa Macao",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/m8ik0lvl_f1.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/m8ik0lvl_f1.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/rhx2uv74_01-redonda-horseback-punta-cana.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/wqlpxq3q_bf.jpg",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/4nkqigjk_ce379f605cb51017400b8ed41248d418998433a0de009fb0ad707010d6f9b44d.jpg"
    ],
    locations: ["Punta Cana"],
    duration: "3 Horas",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 75,
    childPrice: null,
    priceLabel: "por persona",
    isOffer: false,
    category: "Aventura",
    tag: "Naturaleza",
    description: "Ven y vive esta aventura de montar a caballo donde podrás ir a Playa Macao, darte un chapuzón y disfrutar de una caminata a caballo por la playa y senderos rurales.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Caballo para el recorrido",
      "Guía experto",
      "Recorrido por senderos rurales",
      "Paseo por Playa Macao",
      "Tiempo para nadar en la playa"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel." },
      { title: "Llegada al rancho", desc: "Instrucciones y asignación de caballo." },
      { title: "Paseo", desc: "Cabalgata por senderos rurales hacia la playa." },
      { title: "Playa Macao", desc: "Tiempo libre para nadar y disfrutar." },
      { title: "Regreso", desc: "Cabalgata de vuelta y transporte al hotel." }
    ],
    recommendations: "Pantalones largos, zapatos cerrados, protector solar, traje de baño. Horarios: 8:30 AM, 10:30 AM y 2:30 PM."
  },
  {
    id: 17,
    title: "Monkey Land - Tierra de los Monos",
    image: "https://customer-assets.emergentagent.com/job_canares/artifacts/rghtey9u_monkey-land-v1.webp",
    gallery: [
      "https://customer-assets.emergentagent.com/job_canares/artifacts/rghtey9u_monkey-land-v1.webp",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/nx9xdg4w_monkeyland-safari-2.webp",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/nhx2l0gg_monkeyland-safari-3.webp",
      "https://customer-assets.emergentagent.com/job_canares/artifacts/1o045m79_monkeyland-safari-4.webp"
    ],
    locations: ["Punta Cana"],
    duration: "Medio Día",
    transport: "Ida y Vuelta",
    originalPrice: null,
    salePrice: 85,
    childPrice: 65,
    priceLabel: "por persona",
    isOffer: false,
    category: "Experiencias",
    tag: "Naturaleza",
    description: "Observe monos ardilla en su hábitat natural en lo profundo de la jungla de República Dominicana. Visite el santuario de monos y sus jardines botánicos, conozca las plantaciones locales de café y cacao, y alimente a 20 monos que han sido criados para estar cómodos con las personas.",
    includes: [
      "Transporte ida y vuelta desde tu hotel",
      "Agua y frutas",
      "Alimentar a los monos",
      "Paseo dentro del parque",
      "Visita a plantación de café y cacao",
      "Degustación de café y chocolate caliente",
      "Jardines botánicos",
      "Guía profesional"
    ],
    schedule: [
      { title: "Recogida", desc: "Te buscamos en tu hotel (transporte combinado)." },
      { title: "Llegada al santuario", desc: "Bienvenida y orientación." },
      { title: "Plantaciones", desc: "Visita a plantaciones de café y cacao con degustación." },
      { title: "Monos", desc: "Interacción y alimentación de los monos ardilla." },
      { title: "Jardín botánico", desc: "Recorrido por plantas y flores nativas." },
      { title: "Regreso", desc: "Transporte de vuelta al hotel." }
    ],
    recommendations: "Zapatos cómodos, cámara, efectivo para recuerdos. No recomendado para embarazadas. No apto para personas con alergias severas al maní. Participantes con resfriado o gripe no podrán interactuar con los monos.",
    extraInfo: "Transporte privado disponible por $110 adicionales"
  }
];

export const destinations = [
  {
    id: 1,
    name: "Punta Cana",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/04/Punta-Cana-Categorias-Tours-Excursiones-1357x905px-Stay-Happy-RD.jpg",
    toursCount: 23
  },
  {
    id: 2,
    name: "Saona y Bayahíbe",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/04/Saona-y-Bayahibe-Categorias-Tours-Excursiones-1357x905px-Stay-Happy-RD-2.jpg",
    toursCount: 2
  },
  {
    id: 3,
    name: "La Romana",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/04/La-Romana-Categorias-Tours-Excursiones-1357x905px-Stay-Happy-RD.jpg",
    toursCount: 3
  },
  {
    id: 4,
    name: "Santo Domingo",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/04/Santo-Domingo-Categorias-Tours-Excursiones-1357x905px-Stay-Happy-RD.jpg",
    toursCount: 1
  },
  {
    id: 5,
    name: "Samaná",
    image: "https://potetourstransferpuntacana.com/wp-content/uploads/2021/04/Samana-Categorias-Tours-Excursiones-1357x905px-Stay-Happy-RD.jpg",
    toursCount: 6
  }
];

export const testimonial = {
  author: "TRAMSLOGISTICS OSORIO TLO",
  date: "2024-01-20",
  content: "El mejor para adquirir tus Tour en Punta cana , la mejor experiencia 100%",
  avatar: "T"
};

export const villaImages = [
  "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop"
];

export const navLinks = [
  { label: "Inicio", href: "#inicio", active: true },
  { label: "Traslados", href: "#traslados", active: false },
  { label: "Excursiones", href: "#excursiones", active: false },
  { label: "Reservación de Villas", href: "#villas", active: false }
];

export const languages = [
  { code: "en", flag: "🇺🇸" },
  { code: "fr", flag: "🇫🇷" },
  { code: "de", flag: "🇩🇪" },
  { code: "br", flag: "🇧🇷" },
  { code: "es", flag: "🇪🇸" }
];
